import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styles from "./login.module.css"

export default function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    try {
      const res = await axios.post("https://duhochanquocnewlife.com/api/admin/login", form);

      localStorage.setItem("admin_token", res.data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "Đăng nhập thất bại");
    }
  };

  return (
    <div className={styles.body}>
      <div className={styles.login_container}>
        <div className={styles.login_form}>
          <h2>Admin Login</h2>

          <div className={styles.input_group}>
            <label htmlFor="username">Tên tài khoản</label>
            <input
              id="username"
              onChange={(e) => setForm({ ...form, username: e.target.value })}
            />
          </div>

          <div className={styles.input_group}>
            <label htmlFor="password">Mật khẩu</label>
            <input
              id="password"
              type="password"
              onChange={(e) => {
                setForm({ ...form, password: e.target.value });
                setError("");
              }}
            />
          </div>
          {error && <p className={styles.admin_error}>{error}</p>}

          <button onClick={handleSubmit}>Đăng nhập</button>
        </div>
      </div>
    </div>
  );
}